import ProfileCard from './container';

export default ProfileCard;
